import { Link } from "react-router-dom";

interface TileCardProps {
  title: string;
  description: string;
  label: string;
  to?: string;
  disabled?: boolean;
}

export default function TileCard({
  title,
  description,
  label,
  to,
  disabled = false,
}: TileCardProps) {
  const content = (
    <>
      <div className="tile-card__eyebrow">{label}</div>
      <h3>{title}</h3>
      <p>{description}</p>
      <span className="tile-card__cta">{disabled ? "Coming next" : "Open workspace"}</span>
    </>
  );

  if (disabled || !to) {
    return (
      <article className="tile-card tile-card--disabled" aria-disabled="true">
        {content}
      </article>
    );
  }

  return (
    <Link className="tile-card" to={to}>
      {content}
    </Link>
  );
}
